module.exports = __webpack_public_path__ + "static/media/bannerCyclits.058da724.jpg";